import React, { useState, useContext, useRef, useEffect } from "react";
import useForm from "../../../../services/UseForm";
import '../../../../css/selectSugar.css';
import axios from "axios";
import { API } from "../../../../services/api";
import { UserContext } from "../../../../App";
import logo from '../../../../img/caramel-frappe-17-of-21.jpg';
import { POSContent } from "../pos";

axios.defaults.baseURL = API;

function SelectSugar(props) {

const [disblebtnpayment, setDisblebtnpayment] = useState(1);
const {setShowAlert,LocationID, setErrorMessage, showSelectSugar, setShowSelectSugar, LaoName, setLaoName,TempOrder, setTempOrder,
       ProductID, setProductID, qty, setqty, Retail_Price, setRetail_Price, EngName, setEngName, ProductType, subTotal, 
       setSubTotal, setNetTotal, NewNetTotal, setNewNetTotal, setTax, ImgUrl, setImgUrl,
       setShowOrder} = useContext(POSContent);

    const onClickClose = () => {
        setShowSelectSugar(false);
    }

    function getSelectSugar() {
        const selectedRadio = document.querySelector('input[name="radio"]:checked');
        if (selectedRadio) {
            var c =0;
            var ch = 0;
            for (var i=0; i < TempOrder.length; i++) {
                if (TempOrder[i].ProductID == ProductID) {
                    if(TempOrder[i].Sugar == selectedRadio.value){
                        if(Number(TempOrder[i].Quantity) + Number(qty) > 0){
                            TempOrder[i].Quantity = Number(TempOrder[i].Quantity) + Number(qty);
                            TempOrder[i].SubTotal = Number(TempOrder[i].Quantity) * Number(TempOrder[i].Retail_Price);
                            if(TempOrder[i].PrintStatus === "Y"){
                                if(TempOrder[i].QuantityPrint > 0){
                                    TempOrder[i].QuantityPrint = Number(TempOrder[i].QuantityPrint) + Number(qty);
                                } else {
                                    TempOrder[i].QuantityPrint = qty;
                                }
                            } 
                        } else {
                            TempOrder.splice(i, 1);
                        }
                        c = 1;
                        ch = 1;
                        break;
                    }
                }
            }  

            if(c == 0 || ch == 0){
                var datalist = {
                    SubTotal: Retail_Price,
                    ProductID: ProductID,
                    LaoName: LaoName,
                    EngName: EngName,
                    Retail_Price: Retail_Price,
                    Quantity: Number(qty),
                    Sugar: selectedRadio.value,
                    StatusID : 1,
                    QuantityPrint : 0,
                    PrintStatus: "N",
                    ProductType: ProductType,
                }
                TempOrder.push(datalist);
            }
        } else {
            setErrorMessage("ກະລຸນາເລືອກຄວາມຫວານກ່ອນ");
            setShowAlert(true);
        }
        localStorage.setItem("TemOrderForViewScreen", JSON.stringify(TempOrder));
        getSubtotal();
    }



    const getSubtotal = () => {
        if (TempOrder) {
          if(TempOrder.length > 0){
                var gSubTotal = 0;
                for (var i=0; i < TempOrder.length; i++) {
                    createTemOrder(i);
                    gSubTotal = Number(gSubTotal) + Number(TempOrder[i].SubTotal);
                }  
                var gNewTax = 0;
                var gtax = (Number(gSubTotal) -((Number(gSubTotal) * 100) /110)).toFixed(2);
                setTax(gtax);
                setSubTotal(gSubTotal);
                setNewNetTotal(gSubTotal);
                setNetTotal(gSubTotal);
                createTempTotal(gSubTotal);
                
            } else{
                setSubTotal(0);
                setNetTotal(0);
                setNewNetTotal(0);
                setTax(0);
                DeleteTemOrder();
                DeleteTempTotal();
            }
        } else{
            setSubTotal(0);
            setNewNetTotal(0);
            setNetTotal(0);
            setTax(0);
            DeleteTemOrder();
            DeleteTempTotal();
        }
    }

    async function DeleteTemOrder () {
        let token = localStorage.getItem("token");
        let data;
        data = {
            LocationID: LocationID,
        };
        await axios.post("/DeleteTemOrder", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            //success
        }).catch((err) => {
            console.log(err);
        });
    }
    

     async function createTemOrder (i) {
        let token = localStorage.getItem("token");
        let data;
        data = {
            ProductID: TempOrder[i].ProductID,
            EngName: TempOrder[i].EngName,
            Sugar: TempOrder[i].Sugar,
            Quantity: TempOrder[i].Quantity,
            Price: TempOrder[i].Retail_Price,
            Total: (TempOrder[i].Quantity * TempOrder[i].Retail_Price),
            SubTotal: 0,
            Discount: 0,
            NetTotal: 0,
            PaidAmount: 0,
            ChangeAmount: 0,
            MemberNO: "",
            PreviousBalance: 0,
            NewBalance: 0,
            PreviousPoint: 0,
            NewPoint: 0,
            MemberName: "",
            LocationID: LocationID,
        };
        await axios.post("/createTemOrder", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            //success
        }).catch((err) => {
            console.log(err);
        });
    }

    async function DeleteTempTotal () {
        let token = localStorage.getItem("token");
        let data;
        data = {
            LocationID: LocationID,
        };
        await axios.post("/DeleteTempTotal", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            //success
        }).catch((err) => {
            console.log(err);
        });
    }
    
    async function createTempTotal (gSubTotal) {
        let token = localStorage.getItem("token");
        let data;
        data = {
            SubTotal: gSubTotal,
            Discount: 0,
            NetTotal: gSubTotal,
            PaidAmount: 0,
            ChangeAmount: 0,
            MemberNO: "",
            PreviousBalance: 0,
            NewBalance: 0,
            PreviousPoint: 0,
            NewPoint: 0,
            LocationID: LocationID,
        };
        await axios.post("/CreateTempTotal", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            //success
        }).catch((err) => {
            console.log(err);
        });
    }

    return (
        <div style={{ display: showSelectSugar ? 'flex' : 'none' }} className="SelectSugarForm">
            <div className="SelectSugarContent">
                <div className="leftConten">
                    <div className="Header">
                        <span>ເມນູ# {LaoName+ Retail_Price}</span>
                    </div>
                     <div className="SelectSugarImg">
                        <img className="selectlogo" src={ImgUrl} />
                    </div>
                </div>
                <div className="rightContent">
                    <div className="Header">
                        <div className="btnclose" onClick={e => onClickClose()}>X</div>
                    </div>
                    <div className="body">
                        <div className="bdHeader">
                            <span>ເລືອກຄວາມຫວານ</span>
                        </div>
                        <div className="radioselect">
                            <div class="inputGroup">
                                <input id="radio1" name="radio" type="radio" value="100" defaultChecked />
                                <label for="radio1">ຫວານ: 100%</label>
                            </div>
                            <div class="inputGroup">
                                <input id="radio2" name="radio" type="radio" value="50"/>
                                <label for="radio2">ຫວານ: 50%</label>
                            </div>
                            <div class="inputGroup">
                                <input id="radio3" name="radio" type="radio" value="20"/>
                                <label for="radio3">ຫວານ: 20%</label>
                            </div>
                            <div class="inputGroup">
                                <input id="radio4" name="radio" type="radio" value="0"/>
                                <label for="radio4">ບໍ່ຫວານ</label>
                            </div>
                        </div>
                        <div className="footer">
                            <div className="btn-Payment">
                                <button className="btn" onClick={e => getSelectSugar()}>ຢືນຢັນ</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default SelectSugar;
